namespace Nobox {
    export interface DashboardCampaignPageModel {
        Draft?: number;
        Process?: number;
        Done?: number;
        Cancel?: number;
        Total?: number;
        CampaignGroupYearTotal?: Nobox.Nobox.Pages.campaignGroup[];
        CampaignGroupYearDone?: Nobox.Nobox.Pages.campaignGroup[];
        LastCampaign?: Nobox.Nobox.CampaignRow[];
    }
}
